<template>
  <div data-testid="ReferencesModalContent">
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-html="sanitizeHtml(candidate.referrals)" />
    <hr v-if="candidate.website" class="mt-4" />
    <b-form-group
      v-if="candidate.website"
      label-cols-sm="3"
      label-class="py-0"
      label="Website:"
    >
      <b-link :href="site" target="_blank">{{ candidate.website }}</b-link>
    </b-form-group>
  </div>
</template>

<script>
import sanitizeHtml from 'sanitize-html'

export default {
  name: 'ReferencesModalContent',
  props: {
    candidate: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    site() {
      return this.candidate.website &&
        this.candidate.website.indexOf('http') === -1
        ? `http://${this.candidate.website}`
        : this.candidate.website
    }
  },
  methods: {
    sanitizeHtml
  }
}
</script>
